import { Footer } from '@cscglobal-tbs/react-components-core';
import { makeStyles } from '@fluentui/react-components';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetAppVersionCalculationReviewVersion } from '../../api/app-version/app-version';
import { useCurrentEnterprise } from '../../contexts/useCurrentEnterprise';
import { useUserSettings } from '../../contexts/useUserSettings';
import { FOOTER_SIZE, NAVBAR_SIZE, SIDEMENU_SIZE } from '../../utils/Style.constants';

const useStyles = makeStyles({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        position: 'fixed',
        height: FOOTER_SIZE,
        bottom: 0,
        width: `calc(100% - ${SIDEMENU_SIZE} - ${NAVBAR_SIZE})`,
    },
    root: {
        '& .fui-Divider': {
            paddingTop: '10px',
            paddingBottom: '10px',
            '::before': {
                borderTopColor: '#F3F2F1', //color of divider in v8 fluent
            },
            '::after': {
                borderTopColor: '#F3F2F1', //color of divider in v8 fluent
            },
        },
    },
});

export const FooterContainer: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const { enterprise: enterpriseData } = useCurrentEnterprise();
    const { data: versionData } = useGetAppVersionCalculationReviewVersion();
    const userSettings = useUserSettings();

    const styles = useStyles();

    const version: string = versionData ?? t('loading');
    const build: string = userSettings?.buildVersion ?? t('loading');
    const environment: string = userSettings.environmentName ?? t('loading');
    const enterprise: string = enterpriseData?.enterpriseName ?? t('loading');

    return (
        <div className={styles.wrapper}>
            <Footer version={version} build={build} environment={environment} enterprise={enterprise} className={styles.root} />
        </div>
    );
};
